export default "__VITE_ASSET__DWV1a5Ym__"